import { render, staticRenderFns } from "./open-live.vue?vue&type=template&id=4253874a&scoped=true&"
import script from "./open-live.vue?vue&type=script&lang=js&"
export * from "./open-live.vue?vue&type=script&lang=js&"
import style0 from "./open-live.vue?vue&type=style&index=0&id=4253874a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4253874a",
  null
  
)

export default component.exports